import { render, staticRenderFns } from "./OAuth.vue?vue&type=template&id=0b672e2b&scoped=true"
import script from "./OAuth.vue?vue&type=script&lang=js"
export * from "./OAuth.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=0b672e2b&prod&scoped=true&lang=css&external"
import style1 from "./OAuth.vue?vue&type=style&index=1&id=0b672e2b&prod&scoped=true&lang=css"
import style2 from "./OAuth.vue?vue&type=style&index=2&id=0b672e2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b672e2b",
  null
  
)

export default component.exports